import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlAssetsCustom } from "utils/common";
const VerifiSuccessPage = (props) => {
  const navigate = useNavigate();
    const [giftData, setGiftData] = useState(null);
    useEffect(() => {

      localStorage.removeItem("scroolToElement");
const saved = localStorage.getItem("giftData");

if (saved) {
  try {
    setGiftData(JSON.parse(saved));
  } catch (e) {
    console.error("giftData JSON parse error", e);
  }
}

document.body.classList.add("home-page");

return () => {
  document.body.classList.remove("home-page");
};


}, []);
   const handleScroolToElementAction = (elementId) => {
    
      localStorage.setItem("scroolToElement", elementId);
      navigate("/");
   
  };
 

  return (
    <div className="verifi-success-page">
        <div className="container">
        <div className="verifi-success-box">
            <img
            className="img-full"
            src={urlAssetsCustom("assets/img/img-vr-success.png")}
            alt="verifi-success"
            />
           
            <p className="desc-verifi-success">
           {giftData?.giftName} vừa được gửi qua số điện thoại đã đăng kí. Cảm ơn bạn đã tham gia chương trình cùng Sunlight
            </p></div>
        </div>
        <div className="box-control-bt">
            <img
            className="img-full"
            src={urlAssetsCustom("assets/img/BG-footer.png")}
            alt="line-bt"
            /> 
           
             <div className="box-control-img container ">
                          
                          <img onClick={() => handleScroolToElementAction("box-1")}
                            className="img-control bo2"
                            src={urlAssetsCustom("assets/img/bo2.png")}
                            alt="line-bt"
                          />
                          <img onClick={() => handleScroolToElementAction("box-2")}
                            className="img-control bo3"
                            src={urlAssetsCustom("assets/img/bo3.png")}
                            alt="line-bt"
                          /> 
                          <img onClick={() => handleScroolToElementAction("box-3")}
                            className="img-control bo4"
                            src={urlAssetsCustom("assets/img/bo4.png")}
                            alt="line-bt"
                          /> 
                        </div>
        </div>
       
       
    </div>
  );
};
export default VerifiSuccessPage;
